import { SET_VENDOR_CUSTOMER_STATEMENT } from "../Types/VendorCustomerStatementTypes";
const initialState = {
    vendorCustomerStatementReports: [],
}

const vendorCustomerStatementReducer = (state = initialState, action) => {
  if (action.type === SET_VENDOR_CUSTOMER_STATEMENT) {
    return { ...state, vendorCustomerStatementReports: action.payLoad };
  } else {
    return state;
  }
}

export default vendorCustomerStatementReducer;